import { gettext } from '@eventbrite/i18n';
import React from 'react';

export type Props = {
    orgProfileLink: string;
    organizationNameTruncated: string;
};

export const OrganizerInfo = ({
    orgProfileLink,
    organizationNameTruncated,
}: Props) => {
    const organizerNameMarkup = {
        __html: gettext(
            '<span className="listing-organizer-by">by</span> <a id="organizer-link-org-panel" href="%(orgProfileLink)s" target="_blank" rel="noreferrer" className="listing-organizer-name text-default">%(organizationNameTruncated)s</a>',
            { orgProfileLink, organizationNameTruncated },
        ).toString(),
    };

    return (
        <div className="l-mar-top-3">
            <div className="l-media clrfix listing-organizer-title">
                <div className="l-align-left">
                    <div className="listing-organizer-name-container">
                        <div
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={organizerNameMarkup}
                        />
                    </div>
                    <span
                        id="listings-root__follow-organizer_hero"
                        className="follow-organizer__mini-container"
                    ></span>
                </div>
            </div>
        </div>
    );
};
